'use client';

import { useTreeViewContext } from "../internals/TreeViewProvider/index.js";
import { useSelector } from "../internals/hooks/useSelector.js";
import { selectorItemModel } from "../internals/plugins/useTreeViewItems/useTreeViewItems.selectors.js";
export const useTreeItemModel = itemId => {
  const {
    store
  } = useTreeViewContext();
  return useSelector(store, selectorItemModel, itemId);
};